import * as React from 'react';

interface FieldValueProps {
  condition: string;
  children: React.ReactElement | React.ReactElement[];
  currentCondition?: string;
}

export default function DynamicItem(props: FieldValueProps) {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    if (props.condition.split('||').includes(`${props.currentCondition}`)) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [props.currentCondition]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{visible && props.children}</>
  );
}
